import Vue from "vue";
import Router from "vue-router";
import i18n from './i18n'
import store from './store'

Vue.use(Router);

const ifNotAuthenticated = (to, from, next) => {
    if (!store.state.isAuthenticated) {
        return next();
    }
    return next({
        name: 'demand-request'
    });
}

const ifAuthenticated = (to, from, next) => {
    if (store.state.isAuthenticated) {
        return next();
    }
    return next({
        name: 'login',
        query: {
            redirect: window.location.hash.replace("#","")
        }
    });
}

const router = new Router({
    routes: [{
            path: "/bejelentkezes",
            name: "login",
            component: () => import( /* webpackChunkName: "outer" */ "./views/pages/login.vue"),
            meta: {
                layout: 'outer',
                title: i18n.t('Bejelentkezés')
            },
            beforeEnter: ifNotAuthenticated
        },
        {
            path: "/regisztracio",
            name: "registration",
            component: () => import( /* webpackChunkName: "outer" */ "./views/pages/registration.vue"),
            meta: {
                layout: 'outer',
                title: i18n.t('Regisztráció')
            },
            beforeEnter: ifNotAuthenticated
        },
        {
            path: "/elfelejtett-jelszo",
            name: "forgotten-password",
            component: () => import( /* webpackChunkName: "outer" */ "./views/pages/forgotten-password.vue"),
            meta: {
                layout: 'outer',
                title: i18n.t('Elfelejtett jelszó')
            },
            beforeEnter: ifNotAuthenticated
        },
        {
            path: "/uj-jelszo-megadas",
            name: "reset-password",
            component: () => import( /* webpackChunkName: "outer" */ "./views/pages/reset-password.vue"),
            meta: {
                layout: 'outer',
                title: i18n.t('Új jelszó megadás')
            },
            beforeEnter: ifNotAuthenticated
        },
        {
            path: "/",
            name: "demand-request",
            component: () =>
                import( /* webpackChunkName: "demand-request" */ "./views/pages/demand-request.vue"),
            meta: {
                layout: 'main',
                title: i18n.t('Járat igénylés')
            },
            beforeEnter: ifAuthenticated
        },
        {
            path: "/jarat-igenyles/:routeId",
            props: true,
            name: "demand-request-process",
            component: () =>
                import( /* webpackChunkName: "demand-request" */ "./views/pages/demand-request-process.vue"),
            meta: {
                layout: 'main',
                title: i18n.t('Járat igénylés')
            },
            beforeEnter: ifAuthenticated
        },
        {
            path: "/beallitasok",
            name: "settings",
            component: () =>
                import( /* webpackChunkName: "settings" */ "./views/pages/settings.vue"),
            meta: {
                layout: 'main',
                title: i18n.t('Beállítások')
            },
            beforeEnter: ifAuthenticated
        },
        {
            path: "/kedvencek",
            name: "favourites",
            component: () =>
                import( /* webpackChunkName: "favourites" */ "./views/pages/favourites.vue"),
            meta: {
                layout: 'main',
                title: i18n.t('Kedvencek')
            },
            beforeEnter: ifAuthenticated
        },
        {
            path: "/igenyleseim",
            name: "requests",
            component: () =>
                import( /* webpackChunkName: "requests" */ "./views/pages/requests.vue"),
            meta: {
                layout: 'main',
                title: i18n.t('Igényléseim')
            },
            beforeEnter: ifAuthenticated
        }
    ]
});

router.beforeEach((to, from, next) => {
    document.title = i18n.t(to.meta.title) + " | " + "BKK Telebusz"

    document.body.classList.remove('body--layout-main')
    document.body.classList.remove('body--layout-outer')
    document.body.classList.add('body--layout-'+to.meta.layout)

    next()
});

export default router;